export default "/_next/static/images/e143a5f0fda6356d1c84884b44c54194.jpg";